module.exports = __webpack_public_path__ + "static/media/main.9ba0e6f9.png";